import { render, staticRenderFns } from "./verificateCode.vue?vue&type=template&id=1786c939&scoped=true&"
import script from "./verificateCode.vue?vue&type=script&lang=js&"
export * from "./verificateCode.vue?vue&type=script&lang=js&"
import style0 from "./verificateCode.vue?vue&type=style&index=0&id=1786c939&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1786c939",
  null
  
)

export default component.exports